const DAY_SECONDS = 24 * 60 * 60;

const parseTimestamp = (params, key, fallback) => {
  const value = Number(params.get(key));
  return Number.isFinite(value) && value > 0 ? value : fallback;
};

export const createDefaultFilters = (search = '') => {
  const now = Math.floor(Date.now() / 1000);
  const params = new URLSearchParams(search);
  const explicitRange =
    params.has('start_timestamp') || params.has('end_timestamp');
  const requestedRangeSeconds = Number(params.get('range_seconds'));
  const rangeSeconds =
    Number.isFinite(requestedRangeSeconds) && requestedRangeSeconds > 0
      ? requestedRangeSeconds
      : explicitRange
      ? ''
      : DAY_SECONDS;
  const endTimestamp = rangeSeconds
    ? now
    : parseTimestamp(params, 'end_timestamp', now);
  return {
    start_timestamp: rangeSeconds
      ? endTimestamp - rangeSeconds
      : parseTimestamp(params, 'start_timestamp', now - DAY_SECONDS),
    end_timestamp: endTimestamp,
    range_seconds: rangeSeconds,
    request_type: params.get('request_type') || '',
    model_name: params.get('model_name') || '',
    channel_id: params.get('channel_id') || '',
    status_code: params.get('status_code') || '',
    failure_code: params.get('failure_code') || '',
  };
};

export const buildStatsParams = (filters) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (key === 'range_seconds') return;
    if (value !== '' && value !== null && value !== undefined) {
      params.set(key, String(value));
    }
  });
  return params;
};

export const buildStatsPageParams = (filters) => {
  const params = buildStatsParams(filters);
  const rangeSeconds = Number(filters.range_seconds);
  if (Number.isFinite(rangeSeconds) && rangeSeconds > 0) {
    params.set('range_seconds', String(rangeSeconds));
  }
  return params;
};

export const materializeRelativeRange = (
  filters,
  now = Math.floor(Date.now() / 1000)
) => {
  const rangeSeconds = Number(filters.range_seconds);
  if (!Number.isFinite(rangeSeconds) || rangeSeconds <= 0) {
    return { ...filters };
  }
  return {
    ...filters,
    start_timestamp: now - rangeSeconds,
    end_timestamp: now,
  };
};

export const buildDetailUrl = (filters, overrides = {}) => {
  const params = buildStatsPageParams({ ...filters, ...overrides });
  params.set('from', 'stats');
  return `/error_log?${params.toString()}`;
};

export const formatCount = (value) =>
  Number(value || 0).toLocaleString('zh-CN');

export const formatPercent = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? `${number.toFixed(1)}%` : '—';
};

export const formatTimestamp = (timestamp) => {
  if (!timestamp) return '—';
  return new Date(Number(timestamp) * 1000).toLocaleString('zh-CN', {
    hour12: false,
  });
};

export const timestampToInput = (timestamp) => {
  const numericTimestamp = Number(timestamp);
  if (!Number.isFinite(numericTimestamp) || numericTimestamp <= 0) return '';
  const date = new Date(numericTimestamp * 1000);
  const offset = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
};

export const inputToTimestamp = (value) => {
  if (!value) return '';
  const milliseconds = new Date(value).getTime();
  return Number.isFinite(milliseconds) ? Math.floor(milliseconds / 1000) : '';
};

export const statusColor = (statusCode) => {
  if (statusCode >= 500) return 'red';
  if (statusCode >= 400) return 'orange';
  if (statusCode >= 200 && statusCode < 300) return 'yellow';
  return 'grey';
};

export const changeLabel = (value) => {
  if (value === null || value === undefined) {
    return { text: '上期无数据', tone: 'muted' };
  }
  const number = Number(value);
  if (!Number.isFinite(number)) return { text: '上期无数据', tone: 'muted' };
  if (number > 0) return { text: `较上期 +${number.toFixed(1)}%`, tone: 'bad' };
  if (number < 0) return { text: `较上期 ${number.toFixed(1)}%`, tone: 'good' };
  return { text: '与上期持平', tone: 'muted' };
};
